import cta from '~/components/atoms/a-ctas/a-cta-v2.data'

export default {
  eyebrow: null,
  heading: 'We shape digital products with unique DNA.',
  image: {
    alt: 'Entry image.',
    filename:
      '//a.storyblok.com/f/46530/1500x1000/7fe5d7c38b/kyle-glenn-nxt5htlmlge-unsplash.jpg',
  },
  copy: 'At Tribal, our creative heritage stretches all the way back to the pioneers of modern advertising and connects us to one of the world’s largest creative networks.',
  href: {
    url: '/events',
    cached_url: '/events',
  },
  cta: [
    {
      ...cta,
      copy: 'Sign up Now',
      href: {
        url: '/events',
        cached_url: '/events',
      },
      type: 'secondary',
    },
  ],
  component: 'm-card',
}
